let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d6xir")).then(() => parcelRequire('7wMyK'));